<!-- 班级课程z+  -->
<template>
  <el-dialog title="设置学习时间" :visible.sync="dialogVisible" width="860px" :before-close="handleClose">
    <el-form ref="form" :model="form" :rules="rules" label-width="auto">
      <el-row>
        <!-- <el-col :span="12">
          <el-form-item prop="uids" label="任课老师:">
            <el-select v-model="form.uids" filterable placeholder="请选择">
              <el-option
                v-for="item in teacherUserList"
                :key="item.uid"
                :label="item.uname"
                :value="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
        <el-col :span="12">
          <el-form-item prop="checkTime" label="课程考核结束时间:">
            <el-date-picker v-model="form.checkTime" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%"
              :disabled="isSetCheckTime === 1 ? true : false">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item prop="openTime" label="开课时间:">
            <el-date-picker v-model="form.openTime" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="endTime" label="结课时间:">
            <el-date-picker v-model="form.endTime" type="datetime" placeholder="选择日期时间"
              value-format="yyyy-MM-dd HH:mm:ss" size="small" style="width: 100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <!-- 教师列表 -->
      <TeacherList ref="teacherlist" :classTeachers="classTeacher"  :phoneNumbers="phoneNumber" :companys="company"></TeacherList>
      <div class="button">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="back">返回</el-button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import * as api2 from '@/api/courseware/checkCourseware'
import * as api from '@/api/ClassManagement/chooseCourse'
import TeacherList from '../teacherList.vue'
export default {
  components: {
    TeacherList,
  },
  props: {
    ids: {
      type: String,
    },
    params: {
      type: Object,
      default: () => { },
    },
    classTeacher: {
      type: String,
    },
    phoneNumber: {
      type: String,
    },
    company: {
      type: String,
    },
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid')
    },
  },
  data() {
    return {
      dialogVisible: true,
      form: {
        openTime: '',
        endTime: '',
        checkTime: '',
      },
      rules: {
        openTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
        endTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
        checkTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
      },
      teacherTableVisible: false,
      selectedList: [],
      teacherUserList: [],
      isSetCheckTime: null,

      
    }
  },
  created() { 
  },
  methods: {
    submit() {
      const that = this
      that.$refs.form.validate(async (valid) => {
        if (valid) {
          var openTime = Date.parse(that.form.openTime)
          var endTime = Date.parse(that.form.endTime)
          if (endTime < openTime) {
            that.$message({ type: 'error', message: '结课时间必须大于开课时间' })
          } else {
            var checkTime = Date.parse(that.form.checkTime)
            if (checkTime > endTime || checkTime < openTime) {
              that.$message({ type: 'error', message: '考核时间必须大于开课时间，小于结课时间' })
            } else {
              const uids = that.$refs.teacherlist.uids
              const { code, msg } = (
                await api.setCourseStudyTime({ ...that.form, uids: uids, ids: that.ids })
              ).data
              if (code === 100000) {
                that.$message.success(msg)
                that.back()
              } else {
                that.$message.error(msg)
              }
            }
          }
        }
      })
    },
    back() {
      this.$refs.form.resetFields()
      this.$emit('closeSetCourseLearningTime')
    },
    handleClose() {
      this.$emit('closeSetCourseLearningTime')
    },
    handlerTeacherTable() {
      this.teacherTableVisible = !this.teacherTableVisible
    },


    chooseTeacher() {
      if (this.selectedList.length > 1)
        return this.$message.warning('不能选择超过一位老师')
      this.form.teacherName = this.selectedList[0].name
      this.teacherTableVisible = false
    },
    async handleParam(val) {
      let { code, data } = (await api2.getTeacherUserList(this.getUId)).data
      // console.log(code, data)
      if (code === 100000) {
        this.teacherUserList = data
        if (val.status === 'only') {
          this.form.openTime = val.openTime
          this.form.endTime = val.endTime
          this.form.checkTime = val.checkTime
          this.isSetCheckTime = val.isSetCheckTime
          // console.log('isSetCheckTime',this.isSetCheckTime)
          // console.log('this.teacherUserList', this.teacherUserList)
          this.teacherUserList.forEach((item) => {
            if ((item.uname === val.teacherName)) {
              this.form.uids = item.uid
              return
            }
          })
        }
      }
    },
  },
  watch: {
    params: {
      handler: function (val) {
        this.handleParam(val)
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  background-color: #d7d7d7;

  .el-dialog__title {
    font-weight: 700;
  }
}

/deep/.el-form-item__error {
  position: relative;
}

/deep/.el-dialog__footer {
  .button {
    display: flex;
    justify-content: center;
  }
}

.el-row {
  padding: 10px 0;
  border-bottom: 1px dashed #aaa;
}

/deep/.el-form {
  margin-top: -8px;

  .el-form-item {
    margin-bottom: 0;
  }
}
</style>